import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axioPath from '../../../../../api/axioPath';
import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ReviewsReports(props) {
    let history = useHistory()
    const [value, setValue] = useState(props.tabValue);
    const [contentData, setContentData] = useState([]);
    const [abuseContentData, setAbuseContentData] = useState([]);
    const [finalData, setFinalData] = useState([]);
    const [abuseFinalData, setAbuseFinalData] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalMessage, setModalMessaage] = useState('')
    const [page, setPage] = useState(props.page);
    const [abusePage, setAbusePage] = useState(props.abusePage);
    const [pageCount, setPageCount] = useState(0);
    const [abusePageCount, setAbusePageCount] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        setContentData(props.data)
        setPage(props.page)
        setAbusePage(props.abusePage)
        let pageData = JSON.parse(JSON.stringify(props.data))
        setFinalData(pageData.splice(props.page * 10 - 10, 10))
        if (props.data.length % 10 === 0) {
            setPageCount(props.data.length / 10)
        } else {
            setPageCount(Math.trunc(props.data.length / 10) + 1)
        }

        let abuseContent = props.data.filter(data => data.isReportAbuse !== false)
        setAbuseContentData(abuseContent)
        let abusePageData = JSON.parse(JSON.stringify(abuseContent))
        setAbuseFinalData(abusePageData.splice(props.abusePage * 10 - 10, 10))
        if (abuseContent.length % 10 === 0) {
            setAbusePageCount(abuseContent.length / 10)
        } else {
            setAbusePageCount(Math.trunc(abuseContent.length / 10) + 1)
        }
    }, [props.data])

    const removeComment = (e, index) => {
        e.preventDefault()
        const token = localStorage.getItem("token");
        let data = {}
        axioPath.post(`/user/removeComment?commentId=${finalData[index].id}`, data, {
            headers: {
              Authorization: `${token}`,
            },
          }).then((response) => {
                setModal(!modal)
                if (response.data.message === ' Comment removed successfuly') setModalMessaage('Comment removed successfully')
                else setModalMessaage(response.data.message)
            }).catch((ex) => {
            });
    }

    const removeAbuseComment = (e, index) => {
        e.preventDefault()
        const token = localStorage.getItem("token");
        let data = {}
        axioPath.post(`/user/removeComment?commentId=${abuseFinalData[index].id}`, data, {
            headers: {
              Authorization: `${token}`,
            },
          }).then((response) => {
                setModal(!modal)
                if (response.data.message === ' Comment removed successfuly') setModalMessaage('Comment removed successfully')
                else setModalMessaage(response.data.message)
            }).catch((ex) => {
            });
    }

    const handleToggle = () => {
        setModal(!modal);
        props.func();
    }


    const handlePageChange = (event, value) => {
        setPage(value);
        let pageData = JSON.parse(JSON.stringify(contentData))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleAbusePageChange = (event, value) => {
        setAbusePage(value);
        let abusePageData = JSON.parse(JSON.stringify(abuseContentData))
        setAbuseFinalData(abusePageData.splice(value * 10 - 10, 10))
    };

    return (
        <Container>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Customers Reviews" {...a11yProps(0)} />
                    <Tab label="Abuse Reported" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                {finalData.map((data, index) => {
                    return (
                        <PanelWrapper key={index}>
                            <div style=
                                {{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap:'wrap',
                                }}
                            ><p style={{ flex: '1' }}><span>{data.postedByInfo.companyName}</span>{` review for ${data.postedToInfo.companyName ? data.postedToInfo.companyName : ' '},`}</p>
                                <ActionBtn>
                                    <a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                        onClick={() => {
                                            history.push({
                                                pathname: '/adminCustomerReviews',
                                                search: '?userId=' + data.postedToInfo.userId + '&postType=' + data.userType,
                                                state: { page: page, abusePage: abusePage, tabValue: value }
                                            })
                                        }}
                                    >View All</a>
                                    <button
                                        style={{ color: '#2f3133', border: '0px', backgroundColor: '#bee6f5', borderRadius: '5px', fontSize: '14px' }}
                                        onClick={e => removeComment(e, index)}>
                                        Remove this comment
                                </button>
                                </ActionBtn></div>

                            <p>{`Reviewed Pallets ${data.title} on ${(new Date(data.created * 1000)).toLocaleString()}`}</p>
                            <span style={{ wordBreak: "break-all" }}>Comment : {`${data.comment}`}</span>
                        </PanelWrapper>
                    )
                })}
                {contentData.length !== 0 && <Pagination count={pageCount}
                    page={page}
                    onChange={handlePageChange} />}

            </TabPanel>
            <TabPanel value={value} index={1}>
                {abuseFinalData.map((data, index) => {
                    return (
                        <PanelWrapper key={index}>
                            <div style=
                                {{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            ><p style={{ flex: '1' }}><span>{data.postedByInfo.companyName}</span>{` review for ${data.postedToInfo.companyName ? data.postedToInfo.companyName : ''},`}</p>
                                <ActionBtn>
                                    <a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                        onClick={() => {
                                            history.push({
                                                pathname: '/adminCustomerReviews',
                                                search: '?userId=' + data.postedToInfo.userId + '&postType=' + data.userType,
                                            })
                                        }}
                                    >View All</a>
                                    <button
                                        style={{ color: '#2f3133', border: '0px', backgroundColor: '#bee6f5', borderRadius: '5px', fontSize: '14px' }}
                                        onClick={e => removeAbuseComment(e, index)}>
                                        Remove this comment
                                </button>
                                </ActionBtn></div>

                            <p>{`Reviewed Pallets ${data.title} on ${(new Date(data.created * 1000)).toLocaleString()}`}</p>
                            <span style={{ wordBreak: "break-all" }}>Comment : {`${data.comment}`}</span>
                        </PanelWrapper>
                    )
                })}
                {abuseContentData.length !== 0 && <Pagination count={abusePageCount}
                    page={abusePage}
                    onChange={handleAbusePageChange} />}
            </TabPanel>

            <Modal isOpen={modal}>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleToggle}>OK</Button>
                </ModalFooter>
            </Modal>

        </Container >
    );
}

const Container = styled.div`

`
const PanelWrapper = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    margin: 10px 0;
         p {
            margin:0;
            span {
                color: orange;
            }
        }
        > span {
                margin-top: 15px;
    font-size: 14px;
    display: flex;
        }
`
const ActionBtn = styled.div`

        display: flex;
        justify-content: flex-end;
        > button {
            margin-left: 15px;
        }
`
